import { DATE_FORMATS } from "../../../utils/Constant";
import moment from "moment";
import Tooltip from "../../../components/Common/Tooltip";
import Space from "../../../components/Common/Space";
import {
  FileAddOutlined,
  DeleteOutlined,
  EyeOutlined,
  SearchOutlined,
  EditOutlined,
} from "@ant-design/icons";
import CustomIconInput from "../../../components/CustomForm/CustomIconInput";
import CustomIcon from "../../../components/Common/CustomIcon";
import Colors from "../../../themes/Colors";
import { formatearMontoPesos } from "../../../utils/CurrencyUtil";
import { getNombreProcedimiento } from "./AutorizacionUtils";
import CustomCheckbox from "../../../components/CustomForm/CustomCheckbox";
import CheckRender from "../../../components/Common/CheckRender";
import { TIPO_DOCUMENTO_CORE } from "../../../utils/LocalData";

export const DEFAULT_ICON_AVATAR = "./images/avatar.png";

export const DEFAULT_MOTIVO_CANCELACION = 8;

export const INITIAL_STATE_AUTORIZATION_FORM = {
  numeroAfiliado: "",
  cedula: "",
  nss: "",
  nombres: "",
  apellidos: "",
  edad: "",
  fecha: moment(new Date()).format(DATE_FORMATS.middledash_ymd),
  tipoTelefono: "CEL",
  telefono: "",
  tipoServicio: "",
  correo: "",
  esArl: "No",
  medicoPrescriptor: "",
  diagnostico: "",
  diagnosticoDefinitivo: false,
  requiereFisico: "Si",
  zona: "",
  provincia: "",
  observaciones: "",
  plan: "",
  tipoDocumento: TIPO_DOCUMENTO_CORE.CEDULA,
  esSuplementario: false,
  foto: DEFAULT_ICON_AVATAR,
};

export const DEFAULT_ROW = {
  key: 0,
  codigo: "",
  descripcion: "",
  cantidad: "",
  montoReclamado: "",
  montoAutorizado: "",
  montoDiferencia: "",
};

export const DEFAULT_ROW_DETAIL = {
  key: 0,
  cobertura: "",
  nombreCobertura: "",
  cantidad: "",
  montoReclamado: "",
  montoAutorizado: "",
  montoDiferencia: "",
};

export const DATOS_FIJOS_AUTORIZACION = {
  CODIGO_TIPO_COBERTURA: "04",
  CODIGO_DIAGNOSTICO_NO_CAPTURADO: "Z006",
  FECHA_VALIDA_HASTA: {
    CANTIDAD_TIEMPO: 30,
    INTERVALO_TIEMPO: "days",
  },
};

export const ESTADO_AUTORIZACION = {
  VIGENTE: "VIGENTE",
  CANCELADO: "CANCELADO",
};

export const VOUCHER_AUTORIZACION = {
  HUMANO_ASEGURADO_MATRICIAL: "Voucher_Humano_Asegurado_Matricial",
  HUMANO_ASEGURADO_TERMICO: "Voucher_Humano_Asegurado_Termica",
  HUMANO_PRESTADOR_MATRICIAL: "Voucher_Humano_Prestador_Matricial",
  HUMANO_PRESTADOR_TERMICO: "Voucher_Humano_Prestador_Termica",
  PRIMERA_PRESTADOR_MATRICIAL: "Voucher_ARSprimera_Prestador_Matricial",
  PRIMERA_PRESTADOR_TERMICO: "Voucher_ARSprimera_Prestador_Termica",
};

export const TIPO_ID = {
  PLASTICO: "P",
  CEDULA: "C",
};

export const ESTADO_DIAGNOSTICO_DEFINITIVO = {
  CONFIRMADO: "Confirmado",
  PENDIENTE_CONFIRMAR: "Pendiente confirmar",
};

export const CODIGO_TIPO_SERVICIO_AUTORIZACION = {
  AMBULATORIO: "1",
  EMERGENCIA: "3",
  ODONTOLOGIA: "8",
  PROMOCION_PREVENCION: "6",
  DIALISIS: "71",
  QUIMIOTERAPIA: "72",
  RADIOTERAPIA: "73",
  GMM: "65",
  ALTO_COSTO: "13",
};

export const DESCRIPCION_PLAN = {
  PLAN_BASICO: "PLAN BASICO DE SALUD",
};

export const DATOS_FIJOS_ZONAS = {
  PAIS_ID: 1,
  TIPO_DISTRIBUCION_POLITICA_ID: 381,
  DEFAULT_ZONA: 1,
};

export const DATOS_FIJOS_PROVINCIAS = {
  PAIS_ID: 1,
  TIPO_DISTRIBUCION_POLITICA_ID: 27,
  DEFAULT_PROVINCIA: 1,
};

export const PAGINAS_PROCEDIMIENTOS = {
  PAGINA: 1,
  TAMANO: 10,
};

export const CHECK_DIAGNOSTICO_DEFINITIVO = {
  SI_ES_DEFINITIVO: "S",
  NO_ES_DEFINITIVO: "N",
};

export const CHECK_PRIMERA_CONSULTA = {
  SI_ES_PRIMERA_CONSULTA: "S",
  NO_ES_PRMERA_CONSULTA: "N",
};

export const CHECK_FISICO_REQUERIDO = {
  SI_REQUERIDO: "Si",
  NO_REQUERIDO: "No",
};

export const MAXIMO_DIAS_CONSULTA_DIAGNOSTICOS = 60;

export const CONFIG_VOUCHER = {
  MATRICIAL:
    "width=230,height=850,scrollbars=no,menubar=no,location=no,resizable=no",
  TERMICO:
    "width=300,height=850,scrollbars=no,menubar=no,location=no,resizable=no",
};

export const MOCK_PROCEDIMIENTOS = [
  {
    key: "5663",
    cobertura: "5663",
    nombreCobertura: "CONSULTA AMBULATORIA CIRUGIA TORAXICA",
    cantidad: 1,
    montoReclamado: 500,
    montoAutorizado: 200,
    montoDiferencia: 300,
  },
  {
    key: "5667",
    cobertura: "5667",
    nombreCobertura: "CONSULTA AMBULATORIA GASTROENTEROLOGIA",
    cantidad: 1,
    montoReclamado: 500,
    montoAutorizado: 200,
    montoDiferencia: 300,
  },
  {
    key: "256",
    cobertura: "256",
    nombreCobertura: "HIPEROSALPINFOGRAFIA",
    cantidad: 1,
    montoReclamado: 500,
    montoAutorizado: 200,
    montoDiferencia: 300,
  },
];

export const MOCK_DETALLE_PROCEDIMIENTOS = [
  {
    key: "5663",
    cobertura: "5663",
    nombreCobertura: "CONSULTA AMBULATORIA CIRUGIA TORAXICA",
    cantidad: 1,
    montoReclamado: 500,
    montoAutorizado: 200,
    montoDiferencia: 300,
  },
  {
    key: "256",
    cobertura: "256",
    nombreCobertura: "HIPEROSALPINFOGRAFIA",
    cantidad: 1,
    montoReclamado: 500,
    montoAutorizado: 200,
    montoDiferencia: 300,
  },
];

export const MOCK_LISTA_AUTORIZACIONES = [
  {
    numeroAutorizacion: "H95-1375832",
    fechaServicio: "2021-09-06T21:22:40",
    numeroAsegurado: "123456",
    estado: "Vigente",
    test: "Test",
  },
  {
    numeroAutorizacion: "H95-1375833",
    fechaServicio: "2021-09-06T21:22:40",
    numeroAsegurado: "123456",
    estado: "Vigente",
    test: "Test",
  },
  {
    numeroAutorizacion: "H95-1375834",
    fechaServicio: "2021-09-06T21:22:40",
    numeroAsegurado: "123456",
    estado: "Vigente",
    test: "Test",
  },
  {
    numeroAutorizacion: "H95-1375835",
    fechaServicio: "2021-09-06T21:22:40",
    numeroAsegurado: "123456",
    estado: "Vigente",
    test: "Test",
  },
  {
    numeroAutorizacion: "H95-1375836",
    fechaServicio: "2021-09-06T21:22:40",
    numeroAsegurado: "123456",
    estado: "Vigente",
    test: "Test",
  },
  {
    numeroAutorizacion: "H95-1375837",
    fechaServicio: "2022-09-06T21:22:40",
    numeroAsegurado: "654321",
    estado: "Cancelada",
    test: "Test",
  },
];

export const MOCK_DETALLE_AUTORIZACION = {
  numeroAfiliado: "123456786767",
  cedula: "229-0021148-5",
  nss: "1234",
  nombres: "Jorge Manuel",
  apellidos: "Martinez Gonzalez",
  edad: "29",
  fecha: moment(new Date()).format(DATE_FORMATS.middledash_ymd),
  tipoTelefono: "Célular",
  telefono: "8292971289",
  tipoServicio: "Ambulatorio",
  correo: "dmartinezenfocado@gmail.com",
  esArl: "No",
  medicoPrescriptor: "Gustavo Henrique",
  diagnostico: "NO CAPTURADO",
  foto: "./images/jorge3.jpeg",
};

export const COBERTURAS_MONTOS_MODIFICABLES = [1114, 1067];

export const columnsProcedimientosPermitidos = (onClickAgregar, empresa) => {
  return [
    {
      key: "cobertura",
      title: "Código",
      dataIndex: "cobertura",
    },
    {
      key: "nombreCobertura",
      title: "Descripción",
      dataIndex: "nombreCobertura",
    },
    {
      key: "action",
      title: "Acción",
      render: (text, record) => (
        <Tooltip text="Agregar">
          <FileAddOutlined
            style={{ color: empresa?.COLOR_PRINCIPAL, fontSize: 25 }}
            onClick={() => {
              onClickAgregar(record);
            }}
          />
        </Tooltip>
      ),
    },
  ];
};

export const columnsProcedimientosAgregados = (
  handleOpenModalCoberturas,
  eliminarProcedimiento,
  empresa,
  handleCodigoCobertura,
  codigoCobertura,
  onChangeMontoCobertura,
  montoCobertura,
  tipoServicio
) => {
  return [
    {
      key: "cobertura",
      title: "Código y nombre del procedimiento",
      dataIndex: "cobertura",
      render: (text, record) => {
        return record?.key === 0 ? (
          <CustomIconInput
            type={"text"}
            value={codigoCobertura}
            onChange={handleCodigoCobertura}
            placeholder={"Código de procedimiento"}
            width={"190px"}
            icons={
              <Tooltip text="Buscar">
                <CustomIcon
                  icon={SearchOutlined}
                  style={{ color: empresa?.COLOR_PRINCIPAL, fontSize: 35 }}
                  hoverColor={empresa?.COLOR_SECUNDARIO}
                  onClick={handleOpenModalCoberturas}
                />
              </Tooltip>
            }
          />
        ) : (
          getNombreProcedimiento(record)
        );
      },
    },
    {
      key: "cantidad",
      title: "Cantidad",
      dataIndex: "cantidad",
      render: (text, record) => {
        return record?.key === 0 &&
          tipoServicio === CODIGO_TIPO_SERVICIO_AUTORIZACION.ALTO_COSTO ? (
          <CustomIconInput
            type={"text"}
            value={montoCobertura}
            onChange={onChangeMontoCobertura}
            placeholder={"Monto"}
            width={"190px"}
          />
        ) : (
          text
        );
      },
    },
    {
      key: "montoReclamado",
      title: "Monto Reclamado",
      dataIndex: "montoReclamado",
      render: (text) => formatearMontoPesos(String(text)),
    },
    {
      key: "montoAutorizado",
      title: "Monto Autorizado",
      dataIndex: "montoAutorizado",
      render: (text) => formatearMontoPesos(String(text)),
    },
    {
      key: "montoDiferencia",
      title: "Diferencia",
      dataIndex: "montoDiferencia",
      render: (text) => formatearMontoPesos(String(text)),
    },
    {
      key: "action",
      title: "Acción",
      render: (text, record) => {
        return record?.key !== 0 ? (
          <Tooltip text="Eliminar">
            <DeleteOutlined
              style={{ color: Colors.huMyHealth, fontSize: 25 }}
              onClick={() => {
                eliminarProcedimiento(record);
              }}
            />
          </Tooltip>
        ) : (
          text
        );
      },
    },
  ];
};

export const columnsProcedimientosDetalle = (
  openModalCoberturas,
  empresa,
  onChangeCodigoCobertura,
  codigoCobertura,
  onChangeMontoCobertura,
  montoCobertura
) => {
  return [
    {
      key: "cobertura",
      title: "Código y nombre del procedimiento",
      dataIndex: "cobertura",
      render: (text, record) => {
        return record?.key === 0 ? (
          <CustomIconInput
            type={"text"}
            value={codigoCobertura}
            onChange={onChangeCodigoCobertura}
            placeholder={"Código de procedimiento"}
            width={"190px"}
            icons={
              <Tooltip text="Buscar">
                <CustomIcon
                  icon={SearchOutlined}
                  style={{ color: empresa?.COLOR_PRINCIPAL, fontSize: 35 }}
                  hoverColor={empresa?.COLOR_SECUNDARIO}
                  onClick={openModalCoberturas}
                />
              </Tooltip>
            }
          />
        ) : (
          getNombreProcedimiento(record)
        );
      },
    },
    {
      key: "cantidad",
      title: "Cantidad",
      dataIndex: "cantidad",
      render: (text, record) => {
        return record?.key === 0 ? (
          <CustomIconInput
            type={"text"}
            value={montoCobertura}
            onChange={onChangeMontoCobertura}
            placeholder={"Monto"}
            width={"190px"}
          />
        ) : (
          text
        );
      },
    },
    {
      key: "montoReclamado",
      title: "Monto Reclamado",
      dataIndex: "montoReclamado",
      render: (text) => formatearMontoPesos(String(text)),
    },
    {
      key: "montoAutorizado",
      title: "Monto Autorizado",
      dataIndex: "montoAutorizado",
      render: (text) => formatearMontoPesos(String(text)),
    },
    {
      key: "montoDiferencia",
      title: "Diferencia",
      dataIndex: "montoDiferencia",
      render: (text) => formatearMontoPesos(String(text)),
    },
  ];
};

export const columnsProcedimientosDetalleMadre = (
  openModalCoberturas,
  empresa,
  onChangeCodigoCobertura,
  codigoCobertura,
  onChangeMontoCobertura,
  montoCobertura
) => {
  return [
    {
      key: "cobertura",
      title: "Código y nombre del procedimiento",
      dataIndex: "cobertura",
      render: (text, record) => {
        return record?.key === 0 ? (
          <CustomIconInput
            type={"text"}
            value={codigoCobertura}
            onChange={onChangeCodigoCobertura}
            placeholder={"Código de procedimiento"}
            width={"190px"}
            icons={
              <Tooltip text="Buscar">
                <CustomIcon
                  icon={SearchOutlined}
                  style={{ color: empresa?.COLOR_PRINCIPAL, fontSize: 35 }}
                  hoverColor={empresa?.COLOR_SECUNDARIO}
                  onClick={openModalCoberturas}
                />
              </Tooltip>
            }
          />
        ) : (
          getNombreProcedimiento(record)
        );
      },
    },
    {
      key: "cantidad",
      title: "Cantidad",
      dataIndex: "cantidad",
      render: (text, record) => {
        return record?.key === 0 ? (
          <CustomIconInput
            type={"text"}
            value={montoCobertura}
            onChange={onChangeMontoCobertura}
            placeholder={"Monto"}
            width={"190px"}
          />
        ) : (
          text
        );
      },
    },
    {
      key: "montoReclamado",
      title: "Monto Reclamado",
      dataIndex: "montoReclamado",
      render: (text) => formatearMontoPesos(String(text)),
    },
    {
      key: "montoAutorizacionPrimera",
      title: "Monto Autorizado Primera",
      dataIndex: "montoAutorizacionPrimera",
      render: (text) => formatearMontoPesos(String(text)),
    },
    {
      key: "montoAutorizacionHumano",
      title: "Monto Autorizado Humano",
      dataIndex: "montoAutorizacionHumano",
      render: (text) => formatearMontoPesos(String(text)),
    },
    {
      key: "montoAutorizado",
      title: "Monto Autorizado Total",
      dataIndex: "montoAutorizado",
      render: (text) => formatearMontoPesos(String(text)),
    },
    {
      key: "montoDiferencia",
      title: "Diferencia",
      dataIndex: "montoDiferencia",
      render: (text) => formatearMontoPesos(String(text)),
    },
  ];
};

export const columnsBusquedaAutorizaciones = (
  cancelarAutorizacion,
  verDetalleAutorizacion,
  empresa
) => {
  return [
    {
      key: "numeroAutorizacion",
      title: "Cod. Autorización",
      dataIndex: "numeroAutorizacion",
    },
    {
      key: "fechaServicio",
      title: "Fecha",
      dataIndex: "fechaServicio",
      render: (text, record) =>
        moment(record.fechaServicio).format(DATE_FORMATS.middledash_dmy),
    },
    {
      key: "numeroAsegurado",
      title: empresa?.TIPO_CLIENTE,
      dataIndex: "numeroAsegurado",
    },
    {
      key: "descripcionEstatus",
      title: "Estado",
      dataIndex: "descripcionEstatus",
    },
    {
      key: "action",
      title: "Acción",
      render: (text, record) => (
        <Space size={10}>
          <Tooltip text="Cancelar">
            <DeleteOutlined
              style={{ color: Colors.huMyHealth, fontSize: 25 }}
              onClick={() => {
                cancelarAutorizacion(record);
              }}
            />
          </Tooltip>

          <Tooltip text="Ver Detalle">
            <EyeOutlined
              style={{ color: empresa?.COLOR_PRINCIPAL, fontSize: 25 }}
              onClick={() => {
                verDetalleAutorizacion(record);
              }}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];
};

export const columnsAutorizacionesDiagnostico = (
  confirmarDiagnostico,
  openModalModificarDiagnostico,
  empresa
) => {
  return [
    {
      key: "numeroAutorizacion",
      title: "Número Autorización",
      dataIndex: "numeroAutorizacion",
    },
    {
      key: "numeroPlastico",
      title: `Número ${empresa?.TIPO_CLIENTE}`,
      dataIndex: "numeroPlastico",
    },
    {
      key: "nombreAsegurado",
      title: `Nombre ${empresa?.TIPO_CLIENTE}`,
      dataIndex: "nombreAsegurado",
    },
    {
      key: "fechaServicio",
      title: "Fecha Servicio",
      dataIndex: "fechaServicio",
      render: (text, record) =>
        moment(record.fechaServicio).format(DATE_FORMATS.middledash_dmy),
    },
    {
      key: "diagnostico",
      title: "Diagnóstico",
      dataIndex: "diagnostico",
    },
    {
      key: "estado",
      title: "Estado",
      dataIndex: "estado",
    },
    {
      key: "diagnosticoDefinitivo",
      title: "Diagnóstico Definitivo",
      dataIndex: "diagnosticoDefinitivo",
      render: (text, record) => (
        <Space size={10}>
          <Tooltip
            text={
              record?.esDiagnosticoDefinitivo
                ? "Este diagnóstico ya fue confirmado."
                : `Favor marcar esta opción para confirmar que es el diagnóstico definitivo del ${empresa?.TIPO_CLIENTE}.`
            }
          >
            <CustomCheckbox
              checked={record?.esDiagnosticoDefinitivo}
              checkedColor={empresa?.COLOR_PRINCIPAL}
              uncheckedColor={Colors.blueTransparent}
              checkmarkColor={Colors.white}
              disabled={record?.esDiagnosticoDefinitivo}
              onChange={() => {
                confirmarDiagnostico(record);
              }}
            />
          </Tooltip>

          <CheckRender allowed={!record?.esDiagnosticoDefinitivo}>
            <Tooltip text="Modificar">
              <EditOutlined
                style={{ color: empresa?.COLOR_PRINCIPAL, fontSize: 25 }}
                onClick={() => {
                  openModalModificarDiagnostico(record);
                }}
              />
            </Tooltip>
          </CheckRender>
        </Space>
      ),
    },
  ];
};
